import { Outlet, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import BuyerSidebar from "./BuyerSidebar";
import Spinner from "../../../components/Spinner";
import { List } from "react-bootstrap-icons";
import "../../../styles/buyer-dashboard.css";

export default function BuyerDashboard() {
  const { auth, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (sidebarOpen && window.innerWidth < 992) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => (document.body.style.overflow = "");
  }, [sidebarOpen]);

  if (loading) {
    return (
      <div className="p-4">
        <Spinner /> Loading...
      </div>
    );
  }

  if (!auth || !auth.roles?.includes("BUYER")) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      {/* DESKTOP SIDEBAR */}
      <aside
        className="d-none d-lg-block buyer-sidebar-container"
        style={{ width: 260 }}
      >
        <BuyerSidebar />
      </aside>

      {/* MAIN AREA */}
      <div className="flex-grow-1 d-flex flex-column">
        {/* HEADER */}
        <header className="bg-white border-bottom px-3 py-2 sticky-top d-flex align-items-center gap-3">
          {/* MOBILE BURGER */}
          <button
            className="btn btn-outline-secondary d-lg-none d-flex align-items-center gap-2"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open sidebar"
          >
            <List size={20} /> Menu
          </button>

          <div>
            <h5 className="mb-0 fw-semibold">
              Welcome{auth.firstName ? `, ${auth.firstName}` : ""}
            </h5>
            <small className="text-muted">Manage your orders and account</small>
          </div>
        </header>

        {/* MOBILE SIDEBAR DRAWER */}
        <div
          className={`buyer-sidebar-overlay d-lg-none ${sidebarOpen ? "open" : ""}`}
          onClick={() => setSidebarOpen(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className={`buyer-sidebar-drawer ${sidebarOpen ? "open" : ""}`}
          >
            <BuyerSidebar onNavigate={() => setSidebarOpen(false)} />
          </div>
        </div>

        {/* CONTENT */}
        <main className="flex-grow-1 p-3 bg-light overflow-auto">
          <div className="bg-white rounded shadow-sm p-3">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
